export const PRODUCTHANDOVER_LOADING = "PRODUCTHANDOVER_LOADING";
export const PRODUCTHANDOVER_RESET = "PRODUCTHANDOVER_RESET";
export const GET_PRODUCTHANDOVER = "GET_PRODUCTHANDOVER";
export const GET_PRODUCTHANDOVER_SUCCESS = "GET_PRODUCTHANDOVER_SUCCESS";
export const GET_PRODUCTHANDOVER_FAIL = "GET_PRODUCTHANDOVER_FAIL";
export const DELETE_PRODUCTHANDOVER = "DELETE_PRODUCTHANDOVER"
export const DELETE_PRODUCTHANDOVER_SUCCESS = "DELETE_PRODUCTHANDOVER_SUCCESS"
export const DELETE_PRODUCTHANDOVER_FAIL = "DELETE_PRODUCTHANDOVER_FAIL"
export const UPDATE_PRODUCTHANDOVER = "UPDATE_PRODUCTHANDOVER"
export const UPDATE_PRODUCTHANDOVER_SUCCESS = "UPDATE_PRODUCTHANDOVER_SUCCESS"
export const UPDATE_PRODUCTHANDOVER_FAIL = "UPDATE_PRODUCTHANDOVER_FAIL"
export const ADD_NEW_PRODUCTHANDOVER = "ADD_NEW_PRODUCTHANDOVER"
export const ADD_PRODUCTHANDOVER_SUCCESS = "ADD_PRODUCTHANDOVER_SUCCESS"
export const ADD_PRODUCTHANDOVER_FAIL = "ADD_PRODUCTHANDOVER_FAIL"